import script from "./CompareBracket.vue?vue&type=script&setup=true&lang=js"
export * from "./CompareBracket.vue?vue&type=script&setup=true&lang=js"

import "./CompareBracket.vue?vue&type=style&index=0&id=618a5676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-618a5676"]])

export default __exports__